import { ApplicationId } from '../../constants/global';
import { RouteConstants } from '../../constants/routes';
import { UserStore } from '../../store';
import CookieManager from '../cookies';
import { CookieStorageKeys } from '../cookies/constants';
import {
  ExpireTokenInterface,
  GetTokenInterface,
  SetTokenInterface,
} from './types';

abstract class BaseTokenClient {
  protected static getToken: GetTokenInterface;
  protected static setToken: SetTokenInterface;
  protected static expireToken: ExpireTokenInterface;
}

class AuthTokenManager extends BaseTokenClient {
  private static token: string | null = null;

  protected static getToken: GetTokenInterface = () => {
    if (!AuthTokenManager.token) {
      AuthTokenManager.token = CookieManager.getCookie(
        `${ApplicationId}_${CookieStorageKeys.AUTH_TOKEN}`
      );
    }
    return AuthTokenManager.token;
  };

  protected static setToken: SetTokenInterface = (token) => {
    AuthTokenManager.token = token;
    CookieManager.setCookie({
      cookieName: `${ApplicationId}_${CookieStorageKeys.AUTH_TOKEN}`,
      value: token,
    });
  };

  protected static expireToken: ExpireTokenInterface = () => {
    AuthTokenManager.token = null;
    sessionStorage.clear();
    CookieManager.removeCookie(
      `${ApplicationId}_${CookieStorageKeys.AUTH_TOKEN}`
    );
    UserStore.setState({
      isLoggedIn: false,
      entityCode: null,
      entityCodesList: null,
    });
    if (window?.location?.pathname !== RouteConstants.LOGIN) {
      window?.location?.reload();
    }
  };
}

export default AuthTokenManager;
